import { gql } from 'urql';

export const NucleusDatasetItemDetail = gql`
  query NucleusDatasetItemDetail($datasetItemId: ID!, $modelIds: [ID!]) {
    nucleusDatasetItemDetailById(id: $datasetItemId) {
      ...datasetItemDetail
    }
  }

  fragment datasetItemDetail on NucleusDatasetItem {
    ...datasetItem
    ref_id
    last_edited_at
    metadata {
      key
      value
    }
    autotag_image_items {
      ...autotagItem
    }
    autotag_object_items {
      ...autotagItem
    }
    ground_truth_annotations {
      ...annotationInfo
    }
    ground_truth_edits {
      __typename
      edit_id
      ground_truth_annotation_id
      created_at
      edit_type
      via
      user {
        __typename
        id
        firstName
        lastName
      }
      user_color
      annotation {
        ...annotationProps
      }
    }
    predictions(modelIds: $modelIds) {
      ...prediction
      model_run {
        __typename
        id
        name
        started_at
      }
      metadata_schema {
        fields {
          __typename
          id
          name
          params {
            choices
          }
        }
      }
    }
    segmentation_predictions(modelIds: $modelIds) {
      ...segmentationPrediction
    }
    segmentation {
      ...segmentation
    }
    tasks {
      ...task
    }
    scene {
      __typename
      id
      reference_id
      frame_count
      metadata {
        key
        value
      }
    }
    type
    video_frame
  }

  fragment task on NucleusTask {
    task_id
    subtask_id
    task_status
    task_audit_status
    task_audit_review_comment
    created_at
    completed_at
    project_id
    project_name
    batch_id
    batch_name
    is_stale
    times_redone
  }

  fragment segmentation on NucleusSegmentation {
    mask {
      ...segmentationMask
    }
    annotations {
      ...segment
    }
  }

  fragment segmentationPrediction on NucleusSegmentationPrediction {
    model_run_id
    mask {
      ...segmentationMask
    }
    model_run {
      __typename
      id
      name
    }
    predictions {
      ...segment
    }
  }

  fragment annotationProps on NucleusBaseAnnotationUnion {
    ... on Nucleus2DBox {
      __typename
      id
      label
      x
      y
      width
      height
      metadata
      track_id
    }
    ... on NucleusPolygon {
      __typename
      id
      label
      vertices {
        x
        y
      }
      metadata
      track_id
    }
    ... on NucleusLine {
      __typename
      id
      label
      vertices {
        x
        y
      }
      metadata
      track_id
    }
    ... on NucleusCuboid {
      __typename
      id
      label
      position {
        x
        y
        z
      }
      dimensions {
        x
        y
        z
      }
      yaw
      metadata
      track_id
    }
    ... on NucleusCategory {
      __typename
      id
      label
      taxonomy_name
      metadata
      track_id
    }
    ... on NucleusMultiCategory {
      __typename
      id
      labels
      taxonomy_name
      metadata
      track_id
    }
    ... on NucleusKeypoints {
      __typename
      id
      label
      keypoints {
        x
        y
        visible
      }
      names
      skeleton
      metadata
      track_id
    }
    ... on NucleusLidarSemseg {
      __typename
      id
      label
      metadata
      track_id
    }
  }

  fragment datasetItem on NucleusDatasetItem {
    __typename
    id
    processed_image_url
    processed_image_url_grid
    processed_image_url_compressed
    original_image_url
    processed_video_url
    uploaded_asset_id
    grid_transform_params {
      ...transformParams
    }
    camera_params
    sortMetricText
    type
    ref_id
    metadata {
      key
      value
    }
    original_image_size {
      width
      height
    }
  }

  fragment segmentationMask on NucleusMask {
    __typename
    id
    colorized_image_url
    indexed_image_url
    original_image_url
    dataset_item_id
  }

  fragment segment on NucleusSegment {
    __typename
    id
    properties {
      __typename
      label
      index
      color
      metadata
    }
  }

  fragment annotationInfo on NucleusGroundTruthAnnotation {
    __typename
    id
    dataset_item_id
    dataset_id
    task_id
    audit_status
    audit_comment
    properties {
      ...annotationProps
    }
    metadata_schema {
      fields {
        __typename
        id
        name
        params {
          choices
        }
      }
    }
    edits {
      __typename
      edit_id
      ground_truth_annotation_id
      created_at
      via
      user {
        __typename
        id
        firstName
        lastName
      }
      user_color
      annotation {
        ...annotationProps
      }
    }
  }

  fragment prediction on NucleusModelPrediction {
    __typename
    id
    model_run_id
    confidence
    properties {
      ...annotationProps
    }
  }

  fragment transformParams on NucleusGridTransformParamsUnion {
    ... on CameraGridTransformType {
      __typename
      type
      params {
        matrix
      }
    }
  }

  fragment autotagItem on NucleusAutotagItem {
    __typename
    autotag_id
    name
    score
  }
`;

export * from './useNucleusDatasetItemDetail.generated';
